
export enum KendoGridOperatorName {
    // Note:  this enumeration does not yet have all available Kendo grid operator values.
    Equals = 'eq',
    Contains = 'contains'
}
